import { Box, Paper, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";

export const MessagesContainer = styled(Box)(({ theme }) => ({
  padding: "10px 10px 50px 10px",
  paddingBottom: "calc(50px + env(safe-area-inset-bottom))",
  backgroundColor: "#000000",
  overflowY: "auto",
  overflowX: "hidden",
  display: "flex",
  flexDirection: "column-reverse",
  width: "100%",
  WebkitOverflowScrolling: "touch",
  overscrollBehavior: "none",
  touchAction: "pan-y",
  [theme.breakpoints.up("sm")]: {
    paddingBottom: "calc(70px + env(safe-area-inset-bottom))",
  },
  "& > div": {
    margin: "0 auto",
    width: "100%",
    maxWidth: "1200px",
    padding: "0 16px",
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "stretch",
    height: "auto",
  },
}));

export const MockMessageBubble = styled(Paper)(({ isUser }) => ({
  marginVertical: 2,
  width: "60%",
  height: 36,
  borderRadius: 18,
  alignSelf: isUser ? "flex-end" : "flex-start",
  backgroundColor: isUser
    ? "rgba(255, 59, 48, 0.5)"
    : "rgba(128, 128, 128, 0.5)",
  marginBottom: 16,
  animation: "pulse 2s infinite ease-in-out",
  "@keyframes pulse": {
    "0%": {
      opacity: 0.6,
    },
    "50%": {
      opacity: 0.9,
    },
    "100%": {
      opacity: 0.6,
    },
  },
  marginLeft: isUser ? "auto" : "8px",
  marginRight: isUser ? "8px" : "auto",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
}));

export const MockBubbles = () => {
  const [bubbles, setBubbles] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const bubbleHeight = 36;
    const bubbleMargin = 16;
    const totalBubbleHeight = bubbleHeight + bubbleMargin;

    const viewportHeight = window.innerHeight - 56 - 275;

    const sectionHeight = totalBubbleHeight * 3.5;
    const numberOfSections = Math.ceil(viewportHeight / sectionHeight);

    const newBubbles = [];

    for (let section = 0; section < numberOfSections; section++) {
      const bubblesInSection = Math.floor(Math.random() * 2) + 3;
      const redPosition = Math.floor(Math.random() * bubblesInSection);

      for (let i = 0; i < bubblesInSection; i++) {
        newBubbles.push({
          id: newBubbles.length,
          isUser: i === redPosition,
          width: `${30 + Math.random() * 30}%`,
        });
      }
    }

    setBubbles(newBubbles);
  }, [isMobile]);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      <MessagesContainer
        sx={{
          overscrollBehavior: "none",
          WebkitOverflowScrolling: "touch",
          touchAction: "pan-y",
          opacity: 1,
          pointerEvents: "none",
        }}
      >
        <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          {bubbles.map((bubble) => (
            <MockMessageBubble
              key={bubble.id}
              isUser={bubble.isUser}
              sx={{
                width: bubble.width,
                backgroundColor: bubble.isUser
                  ? "rgba(255, 59, 48, 0.5)"
                  : "rgba(128, 128, 128, 0.5)",
              }}
            />
          ))}
        </Box>
      </MessagesContainer>
    </Box>
  );
};
